/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCategoryPlus = createReactComponent("outline", "category-plus", "IconCategoryPlus", [["path", { "d": "M4 4h6v6h-6zm10 0h6v6h-6zm-10 10h6v6h-6zm10 3h6m-3 -3v6", "key": "svg-0" }]]);

export { IconCategoryPlus as default };
//# sourceMappingURL=IconCategoryPlus.mjs.map
